import { render, staticRenderFns } from "./extraOrderConfirm.vue?vue&type=template&id=58ffd2f6&scoped=true&"
import script from "./extraOrderConfirm.vue?vue&type=script&lang=js&"
export * from "./extraOrderConfirm.vue?vue&type=script&lang=js&"
import style0 from "./extraOrderConfirm.vue?vue&type=style&index=0&id=58ffd2f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ffd2f6",
  null
  
)

export default component.exports